import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { PreviewEmailModalBodyProps } from '../../../../types';
import { PreviewEmailContentBox } from '../PreviewEmailContentBox';
import { PreviewEmailPetitionTitle } from '../PreviewEmailPetitionTitle';
import { PreviewEmailSenderInfo } from '../PreviewEmailSenderInfo';

type PreviewEmailModalBodyPropsReskin = Omit<PreviewEmailModalBodyProps, 'onClose'>;

export function PreviewEmailModalBody({
	emailTitle,
	emailContent,
	petitionTitle,
	userName,
	imageDataUrl,
}: PreviewEmailModalBodyPropsReskin): JSX.Element {
	return (
		<div className="bordered p-4 md:p-6">
			<div className="flex flex-col">
				<Box>
					<Text as="h2" mt={0} mb={16} fontWeight="normal" size="huge" sx={{ fontFamily: 'Helvetica Neue' }}>
						{emailTitle}
					</Text>
				</Box>
				<PreviewEmailSenderInfo userName={userName} />
				<PreviewEmailPetitionTitle title={petitionTitle} userName={userName} />
				<PreviewEmailContentBox subject={emailTitle} body={emailContent} imageDataUrl={imageDataUrl} />
			</div>
		</div>
	);
}
